<template>
    <h1 class="result-title">Password Reset</h1>
    <div class="content">
        <h1>21321</h1>
    </div>
</template>

<style scoped>
    .result-title {
        position: relative;
        background-color: var(--clr-primary);
        padding: 1rem 1rem;
        margin-inline: 2rem;
        color: white;
        font-size: 24px;
        border-radius: 3px;
        box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
        z-index: 1;
    }



    .content {
        overflow-x: auto;
        position: relative;
        background-color: #fff;
        padding: 80px 40px 20px 40px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        border-radius: 3px;
        margin-top: -50px;
        padding-inline: 10px;
        padding-top: -30px;
    }
</style>